(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("algoliaAdminBundle", [], factory);
	else if(typeof exports === 'object')
		exports["algoliaAdminBundle"] = factory();
	else
		root["algoliaAdminBundle"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition